import React from 'react';
import { setFloatableInputVisible } from 'pxc-editor-web/src/actions';
import store from '@/store';
import { checkChildPosToOuterTransform } from '../helpers/calculation';
/**
 * provide events:
 * - onDrag
 * - onDragEnd
 **/
export default function svgElementDraggableListener(Component) {
    return class extends React.Component {

        constructor(props) {
            super(props);

            this.state = {
                dx: 0,
                dy: 0
            };

            this.onDragHandler = this.onDragHandler.bind(this);
            this.onDragEndHandler = this.onDragEndHandler.bind(this);

            this.svgElNode = null;
        }

        setSvgElRef(svgElNode) {
            if (!this.svgElNode && svgElNode) {
                this.svgElNode = svgElNode;
                this.addSubscriptions();
            }
        }

        addSubscriptions() {
            this.svgElNode.addEventListener('onDrag', this.onDragHandler);
            this.svgElNode.addEventListener('onDragEnd', this.onDragEndHandler);
        }

        onDragHandler(ev) {
            const { core: { floatableInputVisible: isEditModeEnabled } } = store.getState();

            if (isEditModeEnabled) {
                store.dispatch(setFloatableInputVisible(false));
            }

            const {detail: {dx, dy}} = ev;

            if (this.props.draggable) {
                const [corrX, corrY] = checkChildPosToOuterTransform(dx, dy, (this.props.dragTransforms || {}));
                this.setState({ dx: corrX, dy: corrY }, () => {
                    this.dispatchCallbackEvent('onDrag', {...ev.detail, dx: corrX, dy: corrY});
                    this.onDragSent = true;
                });
            }
        }

        onDragEndHandler(ev) {
            const { core: { floatableInputVisible: isEditModeEnabled } } = store.getState();

            if (isEditModeEnabled) {
                store.dispatch(setFloatableInputVisible(true));
            }

            const {detail: {dx, dy}} = ev;

            if (this.onDragSent) {
                const [corrX, corrY] = checkChildPosToOuterTransform(dx, dy, (this.props.dragTransforms || {}));
                this.setState({ dx: 0, dy: 0 }, () => {
                    if (dx !== 0 || dy !== 0 || this.props.onDrag) {
                        this.dispatchCallbackEvent('onDragEnd', {...ev.detail, dx: corrX, dy: corrY});
                    }
                });
            }
        }

        dispatchCallbackEvent(eventName, params) {
            if (typeof(this.props[eventName]) === 'function') {
                try {
                    this.props[eventName](params);
                } catch (ex) {
                    console.error(ex);
                }
            }
        }

        removeSubscriptions() {
            this.svgElNode.removeEventListener('onDrag', this.onDragHandler);
            this.svgElNode.removeEventListener('onDragEnd', this.onDragEndHandler);
        }

        componentWillUnmount() {
            if (this.svgElNode) {
                this.removeSubscriptions();
            }
        }

        render() {
            const { draggable, dragTransforms, onDragEnd, onDrag, ...otherProps } = this.props;

            return <Component {...otherProps} {...this.state} svgElementDraggableRef={draggable ? (elem => this.setSvgElRef(elem)) : () => {}} />;
        }
    };
}
